export default [
  "bg-nid",

  "bg-white",
 
  "bg-light-default",
 
  "bg-dark",
 
  "bg-black",
 
  "bg-blue",
 
  "bg-blue-madison",
  
  "bg-blue-ebonyclay",
 
  "bg-blue-hoki",
 
  "bg-blue-steel",
 
  "bg-blue-soft",
 
  "bg-blue-dark",
 
  "bg-blue-sharp",
 
  "bg-blue-oleo",
 
  "bg-green",
 
  "bg-green-meadow",
 
  "bg-green-seagreen",
 
  "bg-green-turquoise",
 
  "bg-green-haze",
 
  "bg-green-jungle",
 
  "bg-green-soft",
 
  "bg-green-dark",
 
  "bg-green-sharp",
 
  "bg-green-steel",
 
  "bg-grey",
 
  "bg-grey-steel",
 
  "bg-grey-cararra",
 
  "bg-grey-gallery",
 
  "bg-grey-cascade",
 
  "bg-grey-silver",
 
  "bg-grey-salsa",
 
  "bg-grey-salt",
 
  "bg-grey-mint",
 
  "bg-red",
 
  "bg-red-pink",
 
  "bg-red-sunglo",
 
  "bg-red-intense",
 
  "bg-red-thunderbird",
 
  "bg-red-flamingo",
 
  "bg-red-soft",
 
  "bg-red-haze",
 
  "bg-red-mint",
 
  "bg-yellow",
 
  "bg-yellow-gold",
 
  "bg-yellow-casablanca",
 
  "bg-yellow-crusta",
 
  "bg-yellow-lemon",
 
  "bg-yellow-saffron",
 
  "bg-yellow-soft",
 
  "bg-yellow-haze",
 
  "bg-yellow-mint",
 
  "bg-purple",
 
  "bg-purple-plum",
 
  "bg-purple-medium",
 
  "bg-purple-studio",
 
  "bg-purple-wisteria",
 
  "bg-purple-seance",
 
  "bg-purple-intense",
 
  "bg-purple-sharp",
 
  "bg-purple-soft"
 ]